




























import { Component, Vue } from 'vue-property-decorator';
import TitleContainer from '@/components/common/TitleContainer.vue';
import { MetaInfo } from 'vue-meta/types/vue-meta';
import MainButton from '@/main-components/common/MainButton.vue';
import { SubscriptionType } from '@/utils/subscription/subscription.util';
import dayjs from 'dayjs';
import seoDefault from '@/utils/seo-default';

@Component({
  components: {
    TitleContainer,
    MainButton,
  },
  metaInfo(this: PremiumSucess): MetaInfo {
    return {
      title: 'Thank You! |',
      meta: [
        ...seoDefault({
          title: 'Thank You! | Mysoalan',
          description:
            'We are passionate people that want to help all teachers out there to prepare paper exams for any subject. So that teachers can focus more on teaching instead of hassling drafting exam papers while meeting the deadline.',
        }),
      ],
    };
  },
})
export default class PremiumSucess extends Vue {
  datas = [
    {
      label: 'Plan Subscribe',
      text: 'Premium Plan 6 Bulan',
    },
    {
      label: 'Tarikh subscribe',
      text: '24 Aug 2022',
    },
    {
      label: 'Bill Seterusnya',
      text: '24 Feb 2023',
    },
  ];

  get subscriprionDate() {
    const subscriprionTimestamp =
      (this.$route.query['date'] &&
        parseInt(this.$route.query['date'] as string)) ||
      null;

    if (subscriprionTimestamp) {
      return this.$dayjs(subscriprionTimestamp);
    } else {
      return null;
    }
  }

  get subscriptionType() {
    return (this.$route.query['type'] as SubscriptionType) || null;
  }

  get lastDaySubscriprionDate() {
    let lastDaySubscriprionDate: dayjs.Dayjs | string | null = null;

    if (this.subscriprionDate && this.subscriptionType) {
      switch (this.subscriptionType) {
        case SubscriptionType.OneMonth:
          lastDaySubscriprionDate = this.subscriprionDate.add(1, 'month');
          break;
        case SubscriptionType.SixMonth:
          lastDaySubscriprionDate = this.subscriprionDate.add(6, 'months');
          break;
        case SubscriptionType.LifeTime:
          lastDaySubscriprionDate = 'Life Time';
          break;
      }
    }

    return lastDaySubscriprionDate;
  }

  mounted() {
    this.onSubscriptionType();
    this.$sendMpEvent({
      event: this.$mp_value.SubscriptionSuccess,
    });
  }

  onSubscriptionType() {
    this.datas = [
      {
        label: 'Plan Subscribe',
        text:
          this.subscriptionType === SubscriptionType.LifeTime
            ? 'Life Time'
            : this.subscriptionType === SubscriptionType.OneMonth
            ? 'Premium Plan 1 Bulan'
            : 'Premium Plan 6 Bulan',
      },
      {
        label: 'Tarikh subscribe',
        text: this.subscriprionDate
          ? this.subscriprionDate.format('D	MMM YYYY')
          : '',
      },
      {
        label: 'Bill Seterusnya',
        text:
          this.lastDaySubscriprionDate &&
          typeof this.lastDaySubscriprionDate !== 'string'
            ? this.lastDaySubscriprionDate.format('D	MMM YYYY')
            : this.lastDaySubscriprionDate
            ? this.lastDaySubscriprionDate
            : '',
      },
    ];
  }
}
